import React, {useCallback, useMemo, useState, useRef} from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from "react-router-dom";
import Map from "./Map";
import CategoryContainer from "./CategoryContainer";
import ShopContainer from "./ShopContainer";
import Filter from "./Filter";

function Container({CATEGORIES, GAMMES, data, apiKey}) {
    const [categories , setCategories] = useState(CATEGORIES);
    const [gammes , setGammes] = useState(GAMMES);
    const [bounds, setBounds] = useState([]);
    const [hasAutocomplete, setAutocomplete] = useState(false);
    const [hasSelectedCategories, setHasSelectedCategories] = useState(false);
    const [hasSelectedGammes, setHasSelectedGammes] = useState(false);
    const inputRef = useRef(null);
    const [showFilter, setShowFilter] = useState(false);

    const resetCategories = useCallback(() => {
        setCategories(categories.map(function(item) {
            item.isActive = false;
            return item;
        }));
    }, [categories])

    const resetGammes = useCallback(() => {
        setGammes(gammes.map(function(item) {
            item.isActive = false;
            return item;
        }));
    }, [gammes])

    const resetAutocomplete = useCallback(() => {
        inputRef.current.value  = '';
        setAutocomplete(false);
    }, [inputRef.current])

    const resetAll = useCallback(() => {
        resetCategories();
        resetGammes();
        resetAutocomplete();
    }, [])


    const updateBounds = useCallback((data) => {
        setBounds(data);
        updateHasAutocomplete(true);
    }, []);

    const updateHasAutocomplete = useCallback((data) => {
        setAutocomplete(data);
    }, []);


    const filterByCategories = useCallback((shops) => {
        let selectedCategories = categories.filter(cat => cat.isActive);
        setHasSelectedCategories(true)

        if(selectedCategories.length === 0) {
            setHasSelectedCategories(false)
            return shops;
        }

        var result = shops.filter(function(item) {
            let intersection = selectedCategories.filter(c => item.shopCategoriesId.includes(c.id));
            return intersection.length > 0 ;
        });

        return result;

    }, [categories])

    const filterByGammes = useCallback((data) => {
        let selectedGammes = gammes.filter(gamme => gamme.isActive);
        setHasSelectedGammes(true)

        if(selectedGammes.length === 0) {
            setHasSelectedGammes(false)
            return data;
        }

        var result = data.filter(function(item) {
            let intersection = selectedGammes.filter(c => item.productCategoriesId.includes(c.id));
            return intersection.length > 0 ;
        });

        return result;

    }, [gammes])

    const filterByBounds = useCallback((shops) => {
        if(!hasAutocomplete) {
            return shops;
        }
        return shops.filter(function(item) {
            let hasBounds = bounds.find(b => item.id === b.id);

            return hasBounds;
        })

    }, [bounds, hasAutocomplete])
    const filterData = useMemo(() => {
        let result = [];

        result = filterByGammes(data);
        result = filterByCategories(result);
        result = filterByBounds(result);

        return result;
    }, [data, filterByGammes, filterByCategories, filterByBounds, hasAutocomplete])

    const selectCategory = useCallback((category) => {
        var data = categories;

        data = data.map(function(elem) {
            if(elem.id === category.id) {
                elem.isActive =  elem.isActive ? false : true;
            }

            return elem;
        })
        setCategories(data);
    }, [categories])

    const removeActiveCategory = function(category) {
        var data = categories;

        data = data.map(function(elem) {
            if(elem.id === category.id) {
                elem.isActive =  false
            }

            return elem;
        })
        setCategories(data);
    }

    const removeActiveGamme = function(gamme) {
        var data = gammes;

        data = data.map(function(elem) {
            if(elem.id === gamme.id) {
                elem.isActive = false
            }

            return elem;
        })
        setGammes(data)
    }

    const selectGamme = useCallback((gamme) => {
        var data = gammes;

        data = data.map(function(elem) {
            if(elem.id === gamme.id) {
                elem.isActive =  elem.isActive ? false : true;
            }

            return elem;
        })
        setGammes(data);
    }, [gammes])


    const hasFilter = useMemo(() => {
        return hasAutocomplete || hasSelectedCategories || hasSelectedGammes;
    }, [hasAutocomplete, hasSelectedCategories, hasSelectedGammes])

    const messageResult = useMemo(() => {
        if(filterData.length > 1) {
            return `${filterData.length} résultats`;
        }
        if(filterData.length === 1) {
            return `${filterData.length} résultat`;
        }
        if(filterData.length === 0) {
            return "il n'y a pas de résultat"
        }
    }, [filterData])


    return (<div>

        {showFilter &&
            <div className="container-center">
                <Filter resetAll={resetAll} hasFilter={hasFilter} gammes={gammes}  categories={categories} selectCategory={selectCategory} selectGamme={selectGamme} setShowFilter={setShowFilter}/>
            </div>
        }
        <Map removeActiveCategory={removeActiveCategory} removeActiveGamme={removeActiveGamme} categories={categories} gammes={gammes} showFilter={showFilter} setShowFilter={setShowFilter} inputRef={inputRef} data={filterData} googleMapKey={apiKey} updateBounds={updateBounds} updateHasAutocomplete={updateHasAutocomplete}/>
        {hasFilter &&
            <div className="nbResult">{messageResult}</div>
        }
        <ShopContainer data={filterData} categories={categories}/>
    </div>)
}

export default Container;

var elem = document.getElementById('map')
if(elem) {
    ReactDOM.render(
        <Router>
            <Container apiKey={api_key} data={data} CATEGORIES={categories} GAMMES={gammes} path="/" history={history} />
        </Router>
        , elem);
}
